const Logo = () => {
    return ( 
        <div className="w-20 h-14">
            <img src="images/logo.png" alt="" className="h-full w-full"/>
        </div>
     );
}
 
export default Logo;